/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
/* generator-hash: 691b34ce1d275558cef6375375756c6a84dcf8e5d65a07b4a9650a6cdd71266b */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getClientByClientNo: build.query<
      GetClientByClientNoApiResponse,
      GetClientByClientNoApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/Client/${queryArg.clientNo}`,
        params: {
          isBoardPortal: queryArg.isBoardPortal,
        },
      }),
    }),
    postClientByClientNo: build.query<
      PostClientByClientNoApiResponse,
      PostClientByClientNoApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/Client/${queryArg.clientNo}`,
        method: 'POST',
        body: queryArg.contractQueryModel,
      }),
    }),
    getClientByClientIdCasesAndCaseId: build.query<
      GetClientByClientIdCasesAndCaseIdApiResponse,
      GetClientByClientIdCasesAndCaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/client/${queryArg.clientId ?? ':clientId'}/cases/${queryArg.caseId}`,
      }),
    }),
    getClientByClientIdCasesAndCaseIdDocumentsBlobId: build.query<
      GetClientByClientIdCasesAndCaseIdDocumentsBlobIdApiResponse,
      GetClientByClientIdCasesAndCaseIdDocumentsBlobIdApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/client/${queryArg.clientId ?? ':clientId'}/cases/${queryArg.caseId}/documents/${queryArg.blobId}`,
      }),
    }),
    postClientByClientIdCases: build.query<
      PostClientByClientIdCasesApiResponse,
      PostClientByClientIdCasesApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/client/${queryArg.clientId ?? ':clientId'}/cases`,
        method: 'POST',
        body: queryArg.insuranceCaseQueryWithOptionalUnitIdModel,
      }),
    }),
    getByContractIdIsconnectedtoif: build.query<
      GetByContractIdIsconnectedtoifApiResponse,
      GetByContractIdIsconnectedtoifApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/${queryArg.contractId}/isconnectedtoif`,
      }),
    }),
    getByContractId: build.query<
      GetByContractIdApiResponse,
      GetByContractIdApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/${queryArg.contractId}`,
        params: {
          isBoardPortal: queryArg.isBoardPortal,
        },
      }),
    }),
    postByContractIdAlteration: build.mutation<
      PostByContractIdAlterationApiResponse,
      PostByContractIdAlterationApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/${queryArg.contractId}/alteration`,
        method: 'POST',
      }),
    }),
    postCasedrafts: build.mutation<
      PostCasedraftsApiResponse,
      PostCasedraftsApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/casedrafts`,
        method: 'POST',
        body: queryArg.createCaseDraftModel,
      }),
    }),
    deleteCasedraftsByCaseDraftId: build.mutation<
      DeleteCasedraftsByCaseDraftIdApiResponse,
      DeleteCasedraftsByCaseDraftIdApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/casedrafts/${queryArg.caseDraftId}`,
        method: 'DELETE',
      }),
    }),
    getCasedraftsByCaseDraftId: build.query<
      GetCasedraftsByCaseDraftIdApiResponse,
      GetCasedraftsByCaseDraftIdApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/casedrafts/${queryArg.caseDraftId}`,
      }),
    }),
    putCasedraftsByCaseDraftId: build.mutation<
      PutCasedraftsByCaseDraftIdApiResponse,
      PutCasedraftsByCaseDraftIdApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/casedrafts/${queryArg.caseDraftId}`,
        method: 'PUT',
        body: queryArg.updateCaseDraftModel,
      }),
    }),
    deleteCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentId:
      build.mutation<
        DeleteCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentIdApiResponse,
        DeleteCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/insurance/casedrafts/${queryArg.caseDraftId}/attachments/${queryArg.caseDraftAttachmentId}`,
          method: 'DELETE',
        }),
      }),
    getCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentId: build.query<
      GetCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentIdApiResponse,
      GetCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/casedrafts/${queryArg.caseDraftId}/attachments/${queryArg.caseDraftAttachmentId}`,
      }),
    }),
    getCasedraftsCountByContractIdAndStatus: build.query<
      GetCasedraftsCountByContractIdAndStatusApiResponse,
      GetCasedraftsCountByContractIdAndStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/casedrafts/count/${queryArg.contractId}/${queryArg.status}`,
      }),
    }),
    postCasedraftsList: build.query<
      PostCasedraftsListApiResponse,
      PostCasedraftsListApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/casedrafts/query`,
        method: 'POST',
        body: queryArg.caseDraftQueryModel,
      }),
    }),
    postCasedraftsByCaseDraftIdAttachments: build.mutation<
      PostCasedraftsByCaseDraftIdAttachmentsApiResponse,
      PostCasedraftsByCaseDraftIdAttachmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/casedrafts/${queryArg.caseDraftId}/attachments`,
        method: 'POST',
      }),
    }),
    postCasedraftstatusByCaseDraftIdSentToBblAdvisor: build.mutation<
      PostCasedraftstatusByCaseDraftIdSentToBblAdvisorApiResponse,
      PostCasedraftstatusByCaseDraftIdSentToBblAdvisorApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/casedraftstatus/${queryArg.caseDraftId}/sentToBblAdvisor`,
        method: 'POST',
      }),
    }),
    postCasedraftstatusByCaseDraftIdAcceptedByBblAdvisor: build.mutation<
      PostCasedraftstatusByCaseDraftIdAcceptedByBblAdvisorApiResponse,
      PostCasedraftstatusByCaseDraftIdAcceptedByBblAdvisorApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/casedraftstatus/${queryArg.caseDraftId}/acceptedByBblAdvisor`,
        method: 'POST',
      }),
    }),
    postCasedraftstatusByCaseDraftIdRejectedByBblAdvisor: build.mutation<
      PostCasedraftstatusByCaseDraftIdRejectedByBblAdvisorApiResponse,
      PostCasedraftstatusByCaseDraftIdRejectedByBblAdvisorApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/casedraftstatus/${queryArg.caseDraftId}/rejectedByBblAdvisor`,
        method: 'POST',
        body: queryArg.caseDraftRejectionModel,
      }),
    }),
    getCaseTypes: build.query<GetCaseTypesApiResponse, GetCaseTypesApiArg>({
      query: () => ({ url: `/insurance/CaseTypes` }),
    }),
    getInsuranceObjects: build.query<
      GetInsuranceObjectsApiResponse,
      GetInsuranceObjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/InsuranceObjects`,
        params: {
          contractId: queryArg.contractId,
        },
      }),
    }),
    getUnitByUnitId: build.query<
      GetUnitByUnitIdApiResponse,
      GetUnitByUnitIdApiArg
    >({
      query: (queryArg) => ({ url: `/insurance/Unit/${queryArg.unitId}` }),
    }),
    getUnitByUnitIdCasesAndCaseId: build.query<
      GetUnitByUnitIdCasesAndCaseIdApiResponse,
      GetUnitByUnitIdCasesAndCaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/unit/${queryArg.unitId}/cases/${queryArg.caseId}`,
      }),
    }),
    getUnitByUnitIdCasesAndCaseIdDocumentsBlobId: build.query<
      GetUnitByUnitIdCasesAndCaseIdDocumentsBlobIdApiResponse,
      GetUnitByUnitIdCasesAndCaseIdDocumentsBlobIdApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/unit/${queryArg.unitId}/cases/${queryArg.caseId}/documents/${queryArg.blobId}`,
      }),
    }),
    postUnitByUnitIdCases: build.mutation<
      PostUnitByUnitIdCasesApiResponse,
      PostUnitByUnitIdCasesApiArg
    >({
      query: (queryArg) => ({
        url: `/insurance/unit/${queryArg.unitId}/cases`,
        method: 'POST',
        body: queryArg.insuranceCaseQueryWithoutUnitIdModel,
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as insurance }
export type GetClientByClientNoApiResponse =
  /** status 200 OK */ ClientClientNoGet200TextPlainResponseRead
export type GetClientByClientNoApiArg = {
  /** Client number
    <i>Forvaltningsklientnummer</i> */
  clientNo: number
  /** False to include documents that have been published to My page. True to include documents that have been published to board portal.
    <i>False for å inkludere dokumenter som er publisert til Min side. True for å inkludere dokumenter som er publisert til styreportal.</i> */
  isBoardPortal?: boolean
}
export type PostClientByClientNoApiResponse =
  /** status 200 OK */ InsuranceContractModelQueryResultRead
export type PostClientByClientNoApiArg = {
  clientNo: number
  contractQueryModel: ContractQueryModel
}
export type GetClientByClientIdCasesAndCaseIdApiResponse =
  /** status 200 OK */ InsuranceCaseDetailedModel
export type GetClientByClientIdCasesAndCaseIdApiArg = {
  /** Forvaltningsklient id */
  clientId?: string
  /** insuranceCaseIdl */
  caseId: string
}
export type GetClientByClientIdCasesAndCaseIdDocumentsBlobIdApiResponse =
  unknown
export type GetClientByClientIdCasesAndCaseIdDocumentsBlobIdApiArg = {
  /** Client id */
  clientId?: string
  /** Id of the insurance case */
  caseId: string
  /** Id of the blob */
  blobId: number
}
export type PostClientByClientIdCasesApiResponse =
  /** status 200 OK */ InsuranceCaseQueryResultModelQueryResultRead
export type PostClientByClientIdCasesApiArg = {
  /** Forvaltningsklient id */
  clientId?: string
  insuranceCaseQueryWithOptionalUnitIdModel: InsuranceCaseQueryWithOptionalUnitIdModel
}
export type GetByContractIdIsconnectedtoifApiResponse = unknown
export type GetByContractIdIsconnectedtoifApiArg = {
  /** Id of the insurance contract */
  contractId: string
}
export type GetByContractIdApiResponse =
  /** status 200 OK */ InsuranceContractModelRead
export type GetByContractIdApiArg = {
  /** Id of the insure contract */
  contractId: string
  /** False to include documents that have been published to My page. True to include documents that have been published to board portal.
    <i>False for å inkludere dokumenter som er publisert til Min side. True for å inkludere dokumenter som er publisert til styreportal.</i> */
  isBoardPortal?: boolean
}
export type PostByContractIdAlterationApiResponse = unknown
export type PostByContractIdAlterationApiArg = {
  /** Id of the insurance contract */
  contractId: string
}
export type PostCasedraftsApiResponse = /** status 200 OK */ CaseDraftModel
export type PostCasedraftsApiArg = {
  createCaseDraftModel: CreateCaseDraftModel
}
export type DeleteCasedraftsByCaseDraftIdApiResponse = unknown
export type DeleteCasedraftsByCaseDraftIdApiArg = {
  /** Case draft id */
  caseDraftId: string
}
export type GetCasedraftsByCaseDraftIdApiResponse =
  /** status 200 OK */ CaseDraftModel
export type GetCasedraftsByCaseDraftIdApiArg = {
  /** Case Draft Id */
  caseDraftId: string
}
export type PutCasedraftsByCaseDraftIdApiResponse =
  /** status 200 OK */ CaseDraftModel
export type PutCasedraftsByCaseDraftIdApiArg = {
  /** Case Draft Id */
  caseDraftId: string
  updateCaseDraftModel: UpdateCaseDraftModel
}
export type DeleteCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentIdApiResponse =
  unknown
export type DeleteCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentIdApiArg =
  {
    /** Case draft id */
    caseDraftId: string
    /** Case draft attachment id */
    caseDraftAttachmentId: string
  }
export type GetCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentIdApiResponse =
  unknown
export type GetCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentIdApiArg =
  {
    /** Case draft id */
    caseDraftId: string
    /** Case draft attachment id */
    caseDraftAttachmentId: string
  }
export type GetCasedraftsCountByContractIdAndStatusApiResponse =
  /** status 200 OK */ CasedraftsCountContractIdStatusGet200TextPlainResponse
export type GetCasedraftsCountByContractIdAndStatusApiArg = {
  /** Contract Id */
  contractId: string
  /** Case draft status */
  status: number
}
export type PostCasedraftsListApiResponse =
  /** status 200 OK */ CaseDraftListModelQueryResultRead
export type PostCasedraftsListApiArg = {
  caseDraftQueryModel: CaseDraftQueryModel
}
export type PostCasedraftsByCaseDraftIdAttachmentsApiResponse =
  /** status 200 OK */ IActionResult
export type PostCasedraftsByCaseDraftIdAttachmentsApiArg = {
  /** Case draft Id */
  caseDraftId: string
}
export type PostCasedraftstatusByCaseDraftIdSentToBblAdvisorApiResponse =
  unknown
export type PostCasedraftstatusByCaseDraftIdSentToBblAdvisorApiArg = {
  /** Case Draft Id */
  caseDraftId: string
}
export type PostCasedraftstatusByCaseDraftIdAcceptedByBblAdvisorApiResponse =
  unknown
export type PostCasedraftstatusByCaseDraftIdAcceptedByBblAdvisorApiArg = {
  /** Case Draft Id */
  caseDraftId: string
}
export type PostCasedraftstatusByCaseDraftIdRejectedByBblAdvisorApiResponse =
  unknown
export type PostCasedraftstatusByCaseDraftIdRejectedByBblAdvisorApiArg = {
  /** Case Draft Id */
  caseDraftId: string
  caseDraftRejectionModel: CaseDraftRejectionModel
}
export type GetCaseTypesApiResponse =
  /** status 200 OK */ CaseTypesGet200TextPlainResponse
export type GetCaseTypesApiArg = void
export type GetInsuranceObjectsApiResponse =
  /** status 200 OK */ InsuranceObjectsGet200TextPlainResponse
export type GetInsuranceObjectsApiArg = {
  contractId?: string
}
export type GetUnitByUnitIdApiResponse =
  /** status 200 OK */ UnitUnitIdGet200TextPlainResponseRead
export type GetUnitByUnitIdApiArg = {
  /** Id of the unit
    <i>EnhetsId</i> */
  unitId: string
}
export type GetUnitByUnitIdCasesAndCaseIdApiResponse =
  /** status 200 OK */ InsuranceCaseDetailedModel
export type GetUnitByUnitIdCasesAndCaseIdApiArg = {
  /** Enhetsid */
  unitId: string
  /** insuranceCaseIdl */
  caseId: string
}
export type GetUnitByUnitIdCasesAndCaseIdDocumentsBlobIdApiResponse = unknown
export type GetUnitByUnitIdCasesAndCaseIdDocumentsBlobIdApiArg = {
  /** Unit id */
  unitId: string
  /** Id of the insurance case */
  caseId: string
  /** Id of the blob */
  blobId: number
}
export type PostUnitByUnitIdCasesApiResponse =
  /** status 200 OK */ InsuranceCaseQueryResultModelQueryResultRead
export type PostUnitByUnitIdCasesApiArg = {
  /** Forvaltningsklient id */
  unitId: string
  insuranceCaseQueryWithoutUnitIdModel: InsuranceCaseQueryWithoutUnitIdModel
}
export type AttachmentSummaryModel = {
  /** Id of the blob */
  blobId?: number
  /** Filename
    <i>Filnavn</i> */
  fileName?: string | null
  /** MimeType */
  mimeType?: string | null
}
export type InsuranceDocumentModel = {
  /** Document Id */
  id?: number
  /** Name of the person who registered this document
    <i>Navn på person som registrerte dokumentet</i> */
  registeredBy?: string | null
  /** Name of the person who last updated this document
    <i>Navn på person som sist oppdaterte dette dokumentet</i> */
  updatedBy?: string | null
  /** Document type */
  documentType?: string | null
  /** Title of the document
    <i>Dokumenttittel</i> */
  title?: string | null
  /** Attachments for this document (the actual files)
    <i>Vedlegg for dette dokumentet (de faktiske filene)</i> */
  attachments?: AttachmentSummaryModel[] | null
  /** Date and time for when the document was registered */
  registeredDate?: string
  /** Date and time for when the document was last updated */
  updatedDate?: string
  /** Date and time for when the document was dated */
  dated?: string | null
}
export type InsuredObjectModel = {
  /** Id of the insured object
    <i>Id på forsikret objekt</i> */
  id?: string | null
  /** Description
    <i>Beskrivelse</i> */
  description?: string | null
  /** Denomination
    <i>Betegnelse</i> */
  denomination?: string | null
  /** Type of contract
    <i>Kontraktstype</i> */
  contractType?: string | null
  /** Insured sum
    <i>Forsikret sum</i> */
  sum?: number
  /** Excess
    <i>Egenandel</i> */
  excess?: number
  /** Premium
    <i>Premie</i> */
  premium?: number
  /** Description of terms
    <i>Vilkårsbeskrivelse</i> */
  termsDescription?: string | null
  termsDocument?: InsuranceDocumentModel
}
export type InsuranceContractModel = {
  /** Id of the insurance contract
    <i>Id på forsikringsavtalen</i> */
  id?: string | null
  /** Client number
    <i>Forvaltningsklientnummer</i> */
  clientNo?: number
  /** Insurancenumber
    <i>Forsikringsnummer</i> */
  insuranceNumber?: number
  /** Policynumber
    <i>Polisenummer</i> */
  policyNumber?: string | null
  /** Companyname of the insurance provider
    <i>Forsikringsfirmanavn</i> */
  companyName?: string | null
  /** Flag indicating if this is the main policy
    <i>Hovedpolise</i> */
  isMainPolicy?: boolean
  /** Valid from date
    <i>Gyldig fra dato</i> */
  fromDate?: string | null
  /** Excess
    <i>Egenandel</i> */
  excess?: number | null
  /** List of insured objects relevant to the contract
    <i>Liste med forsikrede objekter for gjeldende avtale</i> */
  insuredObjects?: InsuredObjectModel[] | null
  /** List of documents related to the contract
    <i>Liste med dokumenter for gjeldende avtale</i> */
  documents?: InsuranceDocumentModel[] | null
  /** Valid to date
    <i>Gyldig til dato</i> */
  toDate?: string | null
  /** True if contract is marked as canceled
    <i>True hvis avtalen er markert som avsluttet</i> */
  isCanceled?: boolean
  /** Active or Expired - based on FromDate, ToDate and IsCanceled */
  status?: Status
  /** Allow board to create case drafts on contract
    <i>Tillater at styret melder sak</i> */
  allowBoardCaseDraft?: boolean
  /** Allow housing unit owner to create case drafts on contract
    <i>Tillater at hjemmelshaver melder sak fra Min side</i> */
  allowMyPageCaseDraft?: boolean
}
export type InsuranceContractModelRead = {
  /** Id of the insurance contract
    <i>Id på forsikringsavtalen</i> */
  id?: string | null
  /** Client number
    <i>Forvaltningsklientnummer</i> */
  clientNo?: number
  /** Insurancenumber
    <i>Forsikringsnummer</i> */
  insuranceNumber?: number
  /** Policynumber
    <i>Polisenummer</i> */
  policyNumber?: string | null
  /** Companyname of the insurance provider
    <i>Forsikringsfirmanavn</i> */
  companyName?: string | null
  /** Flag indicating if this is the main policy
    <i>Hovedpolise</i> */
  isMainPolicy?: boolean
  /** Valid from date
    <i>Gyldig fra dato</i> */
  fromDate?: string | null
  /** Excess
    <i>Egenandel</i> */
  excess?: number | null
  /** Total premium
    <i>Totalpremie</i> */
  totalPremium?: number | null
  /** List of insured objects relevant to the contract
    <i>Liste med forsikrede objekter for gjeldende avtale</i> */
  insuredObjects?: InsuredObjectModel[] | null
  /** List of documents related to the contract
    <i>Liste med dokumenter for gjeldende avtale</i> */
  documents?: InsuranceDocumentModel[] | null
  /** Valid to date
    <i>Gyldig til dato</i> */
  toDate?: string | null
  /** True if contract is marked as canceled
    <i>True hvis avtalen er markert som avsluttet</i> */
  isCanceled?: boolean
  /** Active or Expired - based on FromDate, ToDate and IsCanceled */
  status?: Status
  /** Allow board to create case drafts on contract
    <i>Tillater at styret melder sak</i> */
  allowBoardCaseDraft?: boolean
  /** Allow housing unit owner to create case drafts on contract
    <i>Tillater at hjemmelshaver melder sak fra Min side</i> */
  allowMyPageCaseDraft?: boolean
}
export type ClientClientNoGet200TextPlainResponse = InsuranceContractModel[]
export type ClientClientNoGet200TextPlainResponseRead =
  InsuranceContractModelRead[]
export type BblErrorModel = {
  /** What went wrong */
  message?: string | null
  /** Stacktrace */
  stackTrace?: string | null
}
export type InsuranceContractModelQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: InsuranceContractModel[] | null
}
export type InsuranceContractModelQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: InsuranceContractModelRead[] | null
}
export type ContractQueryModel = {
  /** Text to search for, accross searchfields */
  searchText?: string | null
  /** Descending or Ascending */
  sortOrder?: SortOrder
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  /** Filter on All, Active or Expired contracts */
  contractStatus?: ContractStatus
  /** Sort on PolicyNumber, CompanyName, IsMainPolicy or Excess */
  sortColumn?: SortColumn
  /** False to include documents that have been published to My page. True to include documents that have been published to board portal.
    <i>False for å inkludere dokumenter som er publisert til Min side. True for å inkludere dokumenter som er publisert til styreportal.</i> */
  isBoardPortal?: boolean
}
export type CaseInfo = {
  /** Case type - Skadetype */
  caseType?: string | null
  /** Case date - skadedato */
  caseDate?: string | null
  /** Case manager - Skadebehandler */
  caseManager?: string | null
  /** Case description - beskrivelse */
  caseDescription?: string | null
}
export type InsuranceInformation = {
  /** Case status - Skadestatus */
  caseStatus?: string | null
  /** If status is active.
    <remarks>If current status is not B_AVSLUTTET = J</remarks> */
  isActive?: boolean
  /** Insurance company - Forsikringsselskap */
  insuranceCompany?: string | null
  /** Policy number - Polisenr */
  policyNo?: string | null
  /** Case number company - Skadenr selskap */
  caseNoCompany?: string | null
}
export type UnitIdentificationFields = {
  /** SsbNo
    PropertyUnitNumber (dwelling number)
    *Bolignummer* */
  ssbNo?: string | null
  /** The section number of the unit (*Seksjonsnummer*) */
  sectionNo?: number | null
  /** The PropertySectionNo number of the unit(*Andelsnummer*) */
  propertySectionNo?: string | null
  /** Bnr(*Bruksnummer*) */
  bnr?: number | null
  /** Propertynumber
   *Enhetsnummer* */
  propertyNumber?: number | null
  /** Property shared number(*Aksjeboenhetsnummer*) */
  propertySharedNo?: string | null
}
export type UnitOwner = {
  /** Full name of owner */
  fullName?: string | null
  /** Email */
  email?: string | null
  /** Phone */
  phone?: string | null
  /** Nameregister id */
  id?: string | null
}
export type CaseDamage = {
  unitIdentificationFields?: UnitIdentificationFields
  /** Address of unit */
  unitAddress?: string | null
  /** Owner(s) of unit */
  owners?: UnitOwner[] | null
  /** Building floor */
  floor?: string | null
  /** Damage description */
  description?: string | null
  /** If this entry - this unit - is the source of the damage.
    <remarks>Skadeopprinnelse</remarks> */
  isSourceOfDamage?: boolean
  /** Unit id of damage */
  unitId?: string | null
}
export type InsuranceCaseDetailedModel = {
  /** Id of case */
  id?: string | null
  /** Case number - Forsikringskadenr */
  caseNo?: number
  information?: CaseInfo
  insurance?: InsuranceInformation
  /** List of all damages connected to the case */
  damages?: CaseDamage[] | null
  /** List of documents connected to the case */
  documents?: InsuranceDocumentModel[] | null
}
export type InsuranceCaseQueryResultModel = {
  id?: string | null
  /** Case number (forsikringsskadenr) */
  caseNo?: number
  /** Case description */
  description?: string | null
  /** Case type (Skadetype) */
  type?: string | null
  /** If status is active.
    <remarks>If current status is not B_AVSLUTTET = J</remarks> */
  isActive?: boolean
  /** Case number company (skadenr selskap) */
  caseNoCompany?: string | null
  /** Case date (skadedato) */
  date?: string | null
  /** Case status */
  status?: string | null
}
export type InsuranceCaseQueryResultModelQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: InsuranceCaseQueryResultModel[] | null
}
export type InsuranceCaseQueryResultModelQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: InsuranceCaseQueryResultModel[] | null
}
export type InsuranceCaseQueryWithOptionalUnitIdModel = {
  /** Text to search for, accross searchfields */
  searchText?: string | null
  /** Descending or Ascending */
  sortOrder?: SortOrder
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  /** FieldName to sort on */
  sortColumn?: SortColumn2
  /** Filter on given statuses */
  status?: Status2
  /** Specify to get cases connected to given unit */
  unitId?: string | null
}
export type CaseDraftAttachmentModel = {
  /** Case draft attachment id */
  caseDraftAttachmentId?: string
  /** File name */
  fileName?: string | null
  /** Content type */
  contentType?: string | null
  /** File size */
  fileSize?: number
  /** File extension */
  fileExtension?: string | null
  /** Created date */
  createdDate?: string
}
export type CaseDraftModel = {
  /** Case draft Id */
  caseDraftId?: string
  /** /Created date */
  createdDate?: string
  /** Updated date */
  updatedDate?: string
  /** Created by id */
  createdById?: string | null
  /** Updated by id */
  updatedById?: string | null
  /** Bbl code */
  bblCode?: string | null
  /** Client id */
  clientId?: string | null
  /** Case draft status (0-Board, 1-Advisor)
   *Status på sak* */
  status?: Status3
  /** Case type id
   *Skadetype fra HF: FSK_SKADETYPE.ID* */
  caseTypeId?: string | null
  /** Policy number
   *Polisenummer fra avtale: FSK_FORSIKRINGSAVTALE.A_POLISENUMMER* */
  policyNumber?: string | null
  /** Case draft date
   *Skadedato* */
  date?: string | null
  /** Short description */
  description?: string | null
  /** Additional property damage (0-No, 1-Yes, 2-Unknown)
   *Skade på løsøre* */
  additionalPropertyDamage?: AdditionalPropertyDamage | null
  /** Additional property damage description
   *Beskrivelse av skade på løsøre* */
  additionalPropertyDamageDescription?: string | null
  /** Place of damage
   *Hvor skjedde skade* */
  placeOfDamage?: PlaceOfDamage | null
  /** Place of damage - Unit Id
   *Id på enhet* */
  placeOfDamageUnitId?: string | null
  /** Place of damage - Building Id (Index number)
   *Indexnr på bygning* */
  placeOfDamageBuildingId?: number | null
  /** Consequential damage (0-No, 1-Yes, 2-Unknown)
   *Følgeskade* */
  consequentialDamage?: ConsequentialDamage | null
  /** Consequential damage description
   *Beskrivelse av følgeskade* */
  consequentialDamageDescription?: string | null
  /** Is someone responsible for damage (0-No, 1-Yes, 2-Unknown)
   *Finnes det ansvarlig for skade* */
  isResponsibleForDamage?: IsResponsibleForDamage | null
  /** Responsible for damage
   *Ansvarlig skadevolder* */
  responsibleForDamage?: string | null
  /** Measures to repair damage
   *Tiltak for å utbedre skade* */
  repairDamageMeasures?: string | null
  /** Need for relocation
   *Behov for fraflytting* */
  needForRelocation?: string | null
  /** Other comments
   *Andre kommentarer* */
  otherComments?: string | null
  /** Board email */
  boardEmail?: string | null
  /** Board contact
   *NavneregisterId på styrekontakt* */
  boardContactNameId?: string | null
  /** Other contact person than board member */
  otherContactPerson?: OtherContactPerson | null
  /** Other contact person name */
  otherContactPersonName?: string | null
  /** Other contact person phone */
  otherContactPersonPhone?: string | null
  /** Other contact person email */
  otherContactPersonEmail?: string | null
  /** Can use email as communication (0-No, 1-Yes, 2-Unknown) */
  emailCommunication?: EmailCommunication | null
  /** States in what application the case draft is created. For example 1-BoardPortal or 2-MyPage. */
  createdInApplication?: CreatedInApplication
  /** Attachments to case draft */
  attachments?: CaseDraftAttachmentModel[] | null
  /** Id of the insurance object
   *Forsikringsobjekt fra FSK_FORSIKRINGSOBJEKT* */
  insuranceObjectId?: string | null
  /** Follow up (1-InsuranceCompany, 2-Bbl) */
  caseFollowUp?: CaseFollowUp | null
  /** Bbl will handle case in in4mo */
  in4mo?: boolean | null
  /** Total cost of damage excl VAT */
  totalDamageCost?: number | null
  /** Policyholder subject to VAT */
  subjectToVat?: boolean | null
  /** Account number */
  bankAccountNumber?: string | null
  /** Reason for rejection */
  declineReason?: string | null
  /** Status for transfer to Haarfagre */
  transferStatus?: TransferStatus
  /** Id of the insurance contract
   *Forsikringsavtale-id* */
  contractId?: string | null
  /** Full name of creator (only set if nameId of caller is different from createdById on case draft)
   *Fulltnavn på navneregister som har opprettet innslaget (kun satt dersom den som henter skademeldingen er en annen en den som opprettet den)* */
  createdByFullName?: string | null
}
export type ProblemDetails = {
  type?: string | null
  title?: string | null
  status?: number | null
  detail?: string | null
  instance?: string | null
  [key: string]: any
}
export type CreateCaseDraftModel = {
  /** Id for the insurance contract */
  contractId?: string | null
  /** Case type id */
  caseTypeId?: string | null
  /** Unit id (when sender is MyPage, this should be set, ignored for BoardPortal) */
  unitId?: string | null
  /** States in what application the case draft is created. For example 1-BoardPortal or 2-MyPage (default). */
  createdInApplication?: CreatedInApplication
}
export type UpdateCaseDraftModel = {
  /** Case type id
   *Skadetype fra HF: FSK_SKADETYPE.ID* */
  caseTypeId?: string | null
  /** Case draft date
   *Skadedato* */
  date?: string | null
  /** Short description */
  description?: string | null
  /** Additional property damage (0-No, 1-Yes, 2-Unknown)
   *Skade på løsøre* */
  additionalPropertyDamage?: AdditionalPropertyDamage | null
  /** Additional property damage description
   *Beskrivelse av skade på løsøre* */
  additionalPropertyDamageDescription?: string | null
  /** Place of damage
   *Hvor skjedde skade* */
  placeOfDamage?: PlaceOfDamage | null
  /** Place of damage - Unit Id
   *Id på enhet* */
  placeOfDamageUnitId?: string | null
  /** Place of damage - Building Id (Index number)
   *Indexnr på bygning* */
  placeOfDamageBuildingId?: number | null
  /** Consequential damage (0-No, 1-Yes, 2-Unknown)
   *Følgeskade* */
  consequentialDamage?: ConsequentialDamage | null
  /** Consequential damage description
   *Beskrivelse av følgeskade* */
  consequentialDamageDescription?: string | null
  /** Is someone responsible for damage (0-No, 1-Yes, 2-Unknown)
   *Finnes det ansvarlig for skade* */
  isResponsibleForDamage?: IsResponsibleForDamage | null
  /** Responsible for damage
   *Ansvarlig skadevolder* */
  responsibleForDamage?: string | null
  /** Measures to repair damage
   *Tiltak for å utbedre skade* */
  repairDamageMeasures?: string | null
  /** Need for relocation
   *Behov for fraflytting* */
  needForRelocation?: string | null
  /** Other comments
   *Andre kommentarer* */
  otherComments?: string | null
  /** Board email */
  boardEmail?: string | null
  /** Board contact
   *NavneregisterId på styrekontakt* */
  boardContactNameId?: string | null
  /** Other contact person than board member */
  otherContactPerson?: OtherContactPerson | null
  /** Other contact person name */
  otherContactPersonName?: string | null
  /** Other contact person phone */
  otherContactPersonPhone?: string | null
  /** Other contact person email */
  otherContactPersonEmail?: string | null
  /** Can use email as communication (0-No, 1-Yes, 2-Unknown) */
  emailCommunication?: EmailCommunication | null
  /** Id of the insurance object
   *Forsikringsobjekt fra FSK_FORSIKRINGSOBJEKT* */
  insuranceObjectId?: string | null
  /** Follow up (1-InsuranceCompany, 2-Bbl) */
  caseFollowUp?: CaseFollowUp | null
  /** Bbl will handle case in in4mo */
  in4mo?: boolean | null
  /** Total cost of damage excl VAT */
  totalDamageCost?: number | null
  /** Policyholder subject to VAT */
  subjectToVat?: boolean | null
  /** Account number */
  bankAccountNumber?: string | null
  /** Reason for rejection */
  declineReason?: string | null
}
export type CasedraftsCountContractIdStatusGet200TextPlainResponse = number
export type CaseDraftListModel = {
  /** Case draft Id */
  caseDraftId?: string
  /** Short description */
  description?: string | null
  /** Case draft date
   *Skadedato* */
  date?: string | null
  /** Case draft status (0-Board, 1-Advisor)
   *Status på sak* */
  status?: Status3
  /** Case type id
   *Skadetype fra HF: FSK_SKADETYPE.ID* */
  caseTypeId?: string | null
  /** Case type name
   *Skadetypenavn fra HF: FSK_SKADETYPE.ID* */
  caseTypeName?: string | null
  /** Id of the insurance contract
   *Forsikringsavtale-id* */
  contractId?: string | null
  /** Status for transfer to Haarfagre */
  transferStatus?: TransferStatus
  /** The application the insurance case draft was created in (1-BoardPortal, 2-MyPage) */
  createdInApplication?: CreatedInApplication
}
export type CaseDraftListModelQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: CaseDraftListModel[] | null
}
export type CaseDraftListModelQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: CaseDraftListModel[] | null
}
export type CaseDraftQueryModel = {
  /** Text to search for, accross searchfields */
  searchText?: string | null
  /** Descending or Ascending */
  sortOrder?: SortOrder
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  /** States in what application the case drafts are viewed. For example 1-BoardPortal or 2-MyPage. */
  viewInApplication?: ViewInApplication
  /** Client Id */
  clientId?: string | null
  /** Unit id (when sender is MyPage, this should be set, ignored for BoardPortal) */
  unitId?: string | null
}
export type IActionResult = object
export type CaseDraftRejectionModel = {
  /** Rejection reason */
  reason?: string | null
}
export type InsuranceCaseTypeModel = {
  /** Unique id */
  id?: string | null
  /** Type */
  type?: string | null
  /** Description */
  name?: string | null
}
export type CaseTypesGet200TextPlainResponse = InsuranceCaseTypeModel[]
export type InsuranceObjectsGet200TextPlainResponse = InsuranceCaseTypeModel[]
export type UnitUnitIdGet200TextPlainResponse = InsuranceContractModel[]
export type UnitUnitIdGet200TextPlainResponseRead = InsuranceContractModelRead[]
export type InsuranceCaseQueryWithoutUnitIdModel = {
  /** Text to search for, accross searchfields */
  searchText?: string | null
  /** Descending or Ascending */
  sortOrder?: SortOrder
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  /** FieldName to sort on */
  sortColumn?: SortColumn2
  /** Filter on given statuses */
  status?: Status4
}
export enum Status {
  All = 'All',
  Active = 'Active',
  Expired = 'Expired',
}
export enum SortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending',
}
export enum ContractStatus {
  All = 'All',
  Active = 'Active',
  Expired = 'Expired',
}
export enum SortColumn {
  PolicyNumber = 'PolicyNumber',
  CompanyName = 'CompanyName',
  IsMainPolicy = 'IsMainPolicy',
  Excess = 'Excess',
}
export enum SortColumn2 {
  CaseNumber = 'CaseNumber',
  CaseNumberCompany = 'CaseNumberCompany',
  CaseDate = 'CaseDate',
  CaseType = 'CaseType',
  CaseStatus = 'CaseStatus',
}
export enum Status2 {
  Active = 'Active',
  Completed = 'Completed',
  All = 'All',
}
export enum Status3 {
  New = 'New',
  SentToBblAdvisor = 'SentToBblAdvisor',
  AcceptedByBblAdvisor = 'AcceptedByBblAdvisor',
  RejectedByBblAdvisor = 'RejectedByBblAdvisor',
}
export enum AdditionalPropertyDamage {
  Unknown = 'Unknown',
  Yes = 'Yes',
  No = 'No',
}
export enum PlaceOfDamage {
  Unknown = 'Unknown',
  CommonArea = 'CommonArea',
  Unit = 'Unit',
  Building = 'Building',
}
export enum ConsequentialDamage {
  Unknown = 'Unknown',
  Yes = 'Yes',
  No = 'No',
}
export enum IsResponsibleForDamage {
  Unknown = 'Unknown',
  Yes = 'Yes',
  No = 'No',
}
export enum OtherContactPerson {
  Unknown = 'Unknown',
  Yes = 'Yes',
  No = 'No',
}
export enum EmailCommunication {
  Unknown = 'Unknown',
  Yes = 'Yes',
  No = 'No',
}
export enum CreatedInApplication {
  Unknown = 'Unknown',
  BoardPortal = 'BoardPortal',
  MyPage = 'MyPage',
}
export enum CaseFollowUp {
  InsuranceCompany = 'InsuranceCompany',
  Bbl = 'Bbl',
}
export enum TransferStatus {
  None = 'None',
  Ready = 'Ready',
  Failed = 'Failed',
  Transferred = 'Transferred',
}
export enum ViewInApplication {
  Unknown = 'Unknown',
  BoardPortal = 'BoardPortal',
  MyPage = 'MyPage',
}
export enum Status4 {
  Active = 'Active',
  Completed = 'Completed',
  All = 'All',
}
export const {
  useGetClientByClientNoQuery,
  usePostClientByClientNoQuery,
  useGetClientByClientIdCasesAndCaseIdQuery,
  useGetClientByClientIdCasesAndCaseIdDocumentsBlobIdQuery,
  usePostClientByClientIdCasesQuery,
  useGetByContractIdIsconnectedtoifQuery,
  useGetByContractIdQuery,
  usePostByContractIdAlterationMutation,
  usePostCasedraftsMutation,
  useDeleteCasedraftsByCaseDraftIdMutation,
  useGetCasedraftsByCaseDraftIdQuery,
  usePutCasedraftsByCaseDraftIdMutation,
  useDeleteCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentIdMutation,
  useGetCasedraftsByCaseDraftIdAttachmentsAndCaseDraftAttachmentIdQuery,
  useGetCasedraftsCountByContractIdAndStatusQuery,
  usePostCasedraftsListQuery,
  usePostCasedraftsByCaseDraftIdAttachmentsMutation,
  usePostCasedraftstatusByCaseDraftIdSentToBblAdvisorMutation,
  usePostCasedraftstatusByCaseDraftIdAcceptedByBblAdvisorMutation,
  usePostCasedraftstatusByCaseDraftIdRejectedByBblAdvisorMutation,
  useGetCaseTypesQuery,
  useGetInsuranceObjectsQuery,
  useGetUnitByUnitIdQuery,
  useGetUnitByUnitIdCasesAndCaseIdQuery,
  useGetUnitByUnitIdCasesAndCaseIdDocumentsBlobIdQuery,
  usePostUnitByUnitIdCasesMutation,
} = injectedRtkApi
